// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { SvgIcon } from '../../'

export const MaxLengthInputLabel = ({ name, maxLength, maxLengthExceeded }) => (
  <span>
    <span className='u-font-weight-bolder slds-p-right_x-small'>
      {name}
    </span>
    <span className='slds-text-body_small slds-text-color_weak'>
      (max length {maxLength}
        {maxLengthExceeded &&
          <SvgIcon
            variant='utility'
            symbol='warning'
            colour='error'
            size='xx-small'
            className='slds-p-left_xx-small slds-p-right_xx-small'
          />
        }
      )
    </span>
  </span>
)

MaxLengthInputLabel.propTypes = {
  name: PropTypes.string.isRequired,
  maxLength: PropTypes.number.isRequired,
  maxLengthExceeded: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/messageplus/employer-bulk-sms-audiences/MaxLengthInputLabel.js